import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";

export interface InventoryHistoryResponse {
  data: InventoryHistoryData[];
  meta: {
    totalRowCount: number;
  };
}

export interface InventoryHistoryData {
  quantity: string;
  quantityChange: number;
  goodsReceivedNote: number;
  createdAt: string;
  upc: Upc;
  upcId: string;
  refId: string;
}

interface Upc {
  name: string;
  upcId: string;
  warehouse: Warehouse;
  email: string;
}

interface Warehouse {
  name: string;
}

interface InventoryHistoryRequest {
  token: string;
  pagination: MRT_PaginationState;
  columnFilters: MRT_ColumnFiltersState;
  sorting: MRT_SortingState;
}

const getInventoryHistoryData = async ({
  token,
  pagination,
  columnFilters,
  sorting,
}: InventoryHistoryRequest): Promise<InventoryHistoryResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.WMS)}/wms/inventory/get-inventory-history-data`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: `${pagination.pageIndex + 1}`,
          pageSize: `${pagination.pageSize}`,
          columnFilters,
          sorting: sorting,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getInventoryHistoryData;
